import { useQuery } from "@tanstack/react-query"
import { listTransactionHistory } from "services/apiPayments";

const useGetTransactionHistory = (page,size,searchTerm,fromDate,toDate,orgFilter) => {

  const {isPending,isSuccess,isError,error,data} = useQuery({
    queryKey:['transactionHistory',page,size,searchTerm,fromDate,toDate,orgFilter],
    queryFn: ()=> listTransactionHistory(page,size,searchTerm,fromDate,toDate,orgFilter),
    keepPreviousData:true,
    staleTime: 2 * 60 * 60 * 1000
  })

  return{isPending,isSuccess,isError,error,data}
}

export default useGetTransactionHistory